<template>
	<div>
		<template v-for="(item,index) in components">
			<template v-if="item.type === InlineModuleTypeEnum.COMPONENT" :key="index">
				<advanced-image-box-component v-if="item.items.type === PageComponentTypeEnum.ADVANCED_IMAGE_BOX" :slides="item.items"/>
				<image-and-text-block-component v-if="item.items.type === PageComponentTypeEnum.IMAGE_AND_TEXT_BLOCK" :component-data="item.items"/>
				<google-maps-component v-if="item.items.type === PageComponentTypeEnum.MAP" :data="item.items"/>
				<table-block-section v-if="item.items.type === PageComponentTypeEnum.TABLE" :data="item.items"/>
			</template>
			<inline-recall v-else-if="item.type === InlineModuleTypeEnum.RECALL"/>
			<inline-document v-else-if="item.type === InlineModuleTypeEnum.DOCUMENT" :components="item"/>
			<inline-form v-else-if="item.type === InlineModuleTypeEnum.FORM" :components="item"/>
			<p v-else v-html="item"></p>
		</template>
	</div>
</template>
<script setup lang="ts">
import {defineAsyncComponent, defineProps, PropType} from "vue";
import {InlineModuleTypeEnum} from "@/WebApp/Views/PageView/Enums/InlineModuleTypeEnum";
const AdvancedImageBoxComponent = defineAsyncComponent(() => import("@WebAppPageSections/AdvancedImageBoxComponent.vue"));
import {PageComponentTypeEnum} from "@SharedEnums/PageComponentTypeEnum";
import ImageAndTextBlockComponent from "@WebAppPageSections/ImageAndTextBlockComponent.vue";
import GoogleMapsComponent from "@WebAppPageSections/GoogleMapsComponent.vue";
import TableBlockSection from "@WebAppPageSections/TableBlockSection.vue";
import InlineRecall from "@/WebApp/Components/InlineComponents/InlineRecall.vue";
import InlineDocument from "@/WebApp/Components/InlineComponents/InlineDocument.vue";
import InlineForm from "@/WebApp/Components/InlineComponents/InlineForm.vue";

const props = defineProps({
	components: {
		type: Array as PropType<any>[],
		required: false
	}
})
</script>
<style scoped>

</style>
